import * as React from 'react';
import { RootState } from '../../store';
import { useSelector } from 'react-redux';
import { TabScreens } from '../../routes';

export const LoginSvg: React.FC = () => {
    const currentTabScreen = useSelector((state: RootState) => state.tabSlice.screen);
    return (
        <svg xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill={currentTabScreen === TabScreens.User
                ? 'var(--main-turquoise)'
                : 'var(--text-color)'}>
                <path fill="none" d="M0 0h24v24H0z" />
                <path d="M4 15h2v5h12V4H6v5H4V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6zm6-4V8l5 4-5 4v-3H2v-2h8z" fill={currentTabScreen === TabScreens.User
                    ? 'var(--main-turquoise)'
                    : 'var(--text-color)'} />
            </g>
        </svg>
    );
};
